import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom';
import queryString from 'query-string'
import { Helmet } from "react-helmet";
import Source from '../../Source'
import Auth from '../../Auth'
import Loading from './Loading'
import { setGrayBody } from './BodyBg'

const title = " - 中国合同库"

const source = new Source();
const auth = new Auth();

export class ViewTemplate extends Component {
    state = {
        template: [],
        categories: [],
        showLoading: true
    }

    download = (id) => {
        if (auth.isSign()) {
            window.location.href = "/api/template/download?id=" + id + "&token=" + auth.token();
        }
        else {
            this.props.history.push({
                pathname: '/login',
                state: { state: { from: this.props.location } }
            })
        }
    }

    buy = (id) => {
        if (auth.isSign()) {
            this.props.history.push(`/Order?templateId=${id}`);
        }
        else {
            this.props.history.push({
                pathname: '/login',
                state: { from: this.props.location }
            })
        }
    }

    componentDidMount() {
        setGrayBody();
        const { id } = this.props.match.params

        if (source.getParam() != undefined) {
            fetch('/api/user/GetPartnerInfo?source=' + source.getParam(), {
                method: 'GET',
            })
                .then(
                    Response => {
                        if (Response.ok) {
                            return Response.json();
                        }
                        throw new Error('no dealer info');
                    }
                )
                .then((json) => {
                    var sourceValue = { brief: json.Brief, name: json.Name, image: json.Image, code: json.Code };
                    this.setState(sourceValue);
                    source.setSource(JSON.stringify(sourceValue));
                })
                .catch(error => console.error(error))
        }

        fetch('/api/template/FindTemplateByNumber?id=' + id, {
            method: 'GET',
        })
            .then(
                Response => {
                    console.log(Response.status)

                    if (Response.ok) {
                        return Response.json();
                    }

                    if (Response.status === 404) {
                        window.location.href = "/NotFound";
                    }

                    throw new Error('服务器错误');
                }
            )
            .then(
                (json) => {
                    this.setState({ template: json, showLoading: false }, () => {
                        console.log(this.state.template)
                    });

                    this.loadCategories(json.Id);
                }

            )
            .catch(error => console.error(error))
    }

    loadCategories = (templateId) => {
        if (templateId !== undefined) {
            fetch("/api/template/FindRelatedCategories?id=" + templateId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(Response => Response.json())
                .then(
                    json => {
                        // console.log(json)
                        this.setState({ categories: json });
                    }

                )
        }
    }

    render() {
        const { template } = this.state

        return (
            <div>
                <Helmet>
                    <title>{template.Title + title}</title>
                </Helmet>
                {
                    template.Id != undefined &&

                    <div className="fts-container fts-bg-gray clearfix pt-4">
                        <div className="clearfix w-box">

                            <div className="viewtemplate-side-l float-left">
                                <div className="viewtemplate-price">

                                    <div>
                                        <span>{Number(template.Price).toFixed(2)}</span> <span>元</span>
                                    </div>

                                </div>
                                <div className="viewtemplate-button-group fts-border-gray-b clearfix">

                                    <div className="font-s center">
                                        {template.Price > 0 ?
                                            <a className="d-block buy" onClick={this.buy.bind(this, template.Id)}>
                                                <span>购买</span>
                                            </a>
                                            :
                                            <a className="d-block buy" onClick={this.download.bind(this, template.Id)}>
                                                <span>下载</span>
                                            </a>
                                        }
                                    </div>

                                </div>
                            </div>


                            <div className="viewtemplate-article fts-bg-gray clearfix float-left">
                                <div className="viewtemplate-content fts-bg-white float-left" ref="content">
                                    <div id="view-content">
                                        <div className="view-content-title">
                                            <div>{template.Title}</div>
                                        </div>
                                        {
                                            template.SubTitle && (
                                                <div className="view-content-title2">
                                                    <div>{template.SubTitle}</div>
                                                </div>
                                            )
                                        }
                                        <div className="view-content-tags">
                                            {
                                                template.IsGovernment && (
                                                    <span className="government">政府示范文本</span>
                                                )
                                            }
                                            {
                                                template.IsCCD && (
                                                    <span className="ccd">已出版</span>
                                                )
                                            }
                                            {
                                                template.Rank > 0 && (
                                                    <span className="rank">推荐</span>
                                                )
                                            }
                                            {
                                                template.IsMultiple && (
                                                    <span className="multiple">系列</span>
                                                )
                                            }
                                        </div>
                                        <div className="view-content-info fts-bg-gray">
                                            {
                                                !this.state.showLoading && (
                                                    (template.VersionTag.length > 0 || template.ContentTag.length > 0) && (
                                                        <div className="clearfix">
                                                            <div>标签</div>
                                                            <div>
                                                                {
                                                                    template.VersionTag && (
                                                                        <div className="version-tag">
                                                                            <div>版本</div>
                                                                            <div>
                                                                                {template.VersionTag.map(name => (
                                                                                    <span key={name}>{name}</span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                                {
                                                                    template.ContentTag.length && (
                                                                        <div className="content-tag">
                                                                            <div>内容</div>
                                                                            <div>
                                                                                {template.ContentTag.map(name => (
                                                                                    <span key={name}>{name}</span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                )
                                            }

                                            {
                                                !this.state.showLoading && (
                                                    (template.SceneFor.length > 0 || template.SceneNotFor.length > 0) && (
                                                        <div className="clearfix">
                                                            <div>场景</div>
                                                            <div>
                                                                {
                                                                    template.SceneFor.length > 0 && (
                                                                        <span className="mr-0">适用于</span>
                                                                    )}
                                                                {template.SceneFor.map(item => (<span key={item}>{item}</span>))}
                                                                {
                                                                    template.SceneNotFor.length > 0 && (
                                                                        <span className="mr-0">不适用于</span>
                                                                    )}
                                                                {template.SceneNotFor.map(item => (<span key={item}>{item}</span>))}
                                                            </div>
                                                        </div>
                                                    )
                                                )
                                            }
                                            {
                                                !this.state.showLoading && (
                                                    template.MainPoints.length > 0 && (
                                                        <div className="clearfix">
                                                            <div>要点</div>
                                                            <div>
                                                                {
                                                                    template.MainPoints.map(item => (
                                                                        <div key={item}>{item}</div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                )
                                            }
                                            {
                                                this.state.categories.length > 0 && (
                                                    <div className="clearfix">
                                                        <div>分类</div>
                                                        <div>
                                                            {
                                                                this.state.categories.map(
                                                                    category => (
                                                                        <a target="_blank" href={'/Search?category=' + category.Id + '&categoryName=' + category.Name} key={category.Id}>{category.Name}</a>
                                                                    )
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            }

                                        </div>
                                        <div id="view-content-text">
                                            {
                                                !template.IsMultiple ? (
                                                    <div>
                                                        <div className="template-content-text" dangerouslySetInnerHTML={{ __html: template.Preview }}></div>
                                                        {
                                                            template.Price > 0 && (
                                                                <div className="text-center">
                                                                    <span>购买后 可下载查看完整内容</span>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                ) : (
                                                        <div className="mb-4">
                                                            {JSON.parse(template.MultipleTemplates).map((item, i) => (
                                                                <div key={`${i}:${item}`}>
                                                                    {
                                                                        item.Number == 0 ? (
                                                                            <span className="bold font-l mb-2 mt-2">{item.Title}</span>
                                                                        ) : (
                                                                                <a href={"D" + item.Number} target="_blank">#{item.Number} {item.Title}</a>
                                                                            )
                                                                    }
                                                                </div>
                                                            ))}

                                                        </div>
                                                    )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="viewtemplate-side-r  float-left">
                                {
                                    template.AuthorId != null && (
                                        <div className="viewtemplate-author">
                                            <div className="viewtemplate-author-avatar fts-bg-gray">
                                                <img src={template.AuthorAvatar} />
                                            </div>
                                            <div className="viewtemplate-author-name font-m font-green-d">
                                                <span>{template.AuthorName}</span>
                                            </div>
                                        </div>
                                    )
                                }
                                <div className="viewtemplate-info font-s">
                                    <ul className="viewtemplate-info-list">
                                        <li><span>编号：</span><span>{template.Number}</span></li>
                                        <li><span>更新：</span><span>{template.PublishedOnText}</span></li>
                                        <li><span>类型：</span><span>{template.TemplateTypeName}</span></li>
                                        <li><span>字数：</span><span>{template.Words}</span></li>
                                    </ul>

                                </div>
                            </div>
                        </div >

                    </div >
                }
              
                <Loading isLoading={this.state.showLoading} />
            </div >
        )
    }
}

export default withRouter(ViewTemplate)